import React, { useEffect, useState } from "react";
//import Plotly from 'plotly.js-dist';
import createPlotlyComponent from "react-plotly.js/factory";
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "lodash";

const Plot = createPlotlyComponent(window.Plotly);

interface Props {
  passableKey:string,
  config: any,
  selectedLayerId: string | null,
  updateHistogramId: number,
  plotConfigs: any,
  updateId: number,
  dwFilters: any,
  setDwFilters: Function,
}

interface DataPoint {
  value: number;
  cls: string;
}

interface Trace {
  x: number[]; // Array of numerical values for the histogram
  name: string; // Name of the class this trace represents
  type: 'histogram'; // Specifies that this trace is for a histogram
  histfunc: 'count' | 'sum' | 'avg' | 'min' | 'max'; // Function used to aggregate data in the histogram
  marker: {
    color: string; // Color of the histogram bars, can be in various formats (e.g., hex, RGB)
  };
  nbinsx?: number; // Optional number of bins for the x-axis, can be omitted if not needed
}

const ClassedHistogramPlot = ({ passableKey, config, selectedLayerId, updateHistogramId, plotConfigs, updateId, dwFilters, setDwFilters }: Props) => {

  console.log("config", config)
  console.log("D112123 dwFilters", dwFilters)

  useEffect(() => {
      console.log("040223 passableKey", passableKey);
      console.log("A022024 plotConfigs", plotConfigs);
      console.log("A022024 config", config);
      console.log("040223 updateId", updateId);
      console.log("040223 updateHistogramId", updateHistogramId);
      console.log("040223 selectedLayerId", selectedLayerId);
  }, [plotConfigs, updateId, config, updateHistogramId, selectedLayerId]);

  const removeFilter = (e:any) => {
    console.log("removeFilter e",e);
    console.log("removeFilter config",config);
    console.log("D112123 removeFilter dwFilters",dwFilters);
    let updatedDwFilter:any = {...dwFilters};
    Object.keys(dwFilters).forEach((key: string) => {
      console.log("D112122 key", key);
      console.log("D112122 config.name", config.name);
      if (config.title === key){
        console.log("removing filter dwFilters[key]",dwFilters[key]);
        delete updatedDwFilter[key];
      }
      if (key === "version"){
        updatedDwFilter[key] = (updatedDwFilter[key] ? parseInt(updatedDwFilter[key]) + 1 : 0).toString();
      }
    })
    console.log("removeFilter updatedDwFilter",updatedDwFilter);
    setDwFilters(updatedDwFilter);
  }
  function graphHover(params:any) {
    console.log("x040223 params", params);
      if(params.points.length > 0) {
        params.event.target.style.cursor = 'pointer';
      }else {
        params.event.target.style.cursor = '';
      }
  }
  console.log("D022024 config", config);
  let colors = {};
  var _data = config?.data;
  var _data_class = config?.classData;
  if (config.categoryColors){;
    let alternateNumber = 0;
    Object.keys(_data_class).forEach((x:any) => {
      console.log("D022024 x", x);
      console.log("D022024 config.categoryColors", config.categoryColors);
      console.log("D022024 config.categoryColors[x]", config.categoryColors[x]);
      var color = null;
      if (config.categoryColors[x]){
        color = config.categoryColors[x].rgb;
     }else{
        color = config.categoryColors.Alternates.rgb[alternateNumber] ? config.categoryColors.Alternates.rgb[alternateNumber] : 'grey'; // use 'grey' as default color if key not found
        alternateNumber++;
      }
      // colors[x] = color;
      _.set(colors, [x], color);
    })
  }

  console.log("041023 _data", _data);
  console.log("C112123 colors", colors);
  const transformDataToTraces = (data: any): any => {
    //const classMap = new Map<string, number[]>();
    console.log("C022024 data", data);
    // Create a trace for each class
    const traces: Trace[] = [];
    Object.keys(data).forEach((className:any) => {
      console.log("C022024 className", className);
      traces.push({
        x: data[className],
        name: className,
        type: "histogram",
        histfunc: "count",
        marker: { color: _.get(colors, className, 'grey') }, //colors[className] ? colors[className] : 'grey' }, // You can assign specific colors if desired
        nbinsx: 10,
      });
    });
    
    return traces;
  };
  let data = transformDataToTraces(_data_class);
  /* should be structured something like this;
    [
      {
        "x": [0.0004, 0.0002, ...], // Values for "Nonpareil"
        "name": "Nonpareil",
        "type": "histogram",
        "histfunc": "count",
        "marker": { "color": <color_for_Nonpareil> },
        "nbinsx": 10
      },
      {
        "x": [0.0028, 0.0005, ...], // Values for "Monterey"
        "name": "Monterey",
        "type": "histogram",
        "histfunc": "count",
        "marker": { "color": <color_for_Monterey> },
        "nbinsx": 10
      },
      {
        "x": [0.0011, 0.00009, ...], // Values for "Wood Colony"
        "name": "Wood Colony",
        "type": "histogram",
        "histfunc": "count",
        "marker": { "color": <color_for_Wood_Colony> },
        "nbinsx": 10
      }
    ]
  */
  console.log("022024 data", data);
  return (
    <>
    {
      //config &&
      <div>
      { dwFilters[config.title]
      ? <div 
          title="Remove filter"
          className={"clearFilter"}
          onClick={(e:any) => (removeFilter(e))}
        >
          <div className={"rotateSlash"} style={{backgroundColor:"#6d757d"}}></div>
          <FontAwesomeIcon icon={faFilter} />
        </div>
      : <></>
      }
      <Plot
          key={passableKey}
          config={{
            displayModeBar: false,
            //responsive: true
          }}            
          data={data}//{config.traces}
          //layout={config.layout}
          layout={{
            hovermode:"closest",  //"x unified",
            margin: {
                t: 20,
                b: 125,
                l: 35,
                r: 5
            },
            legend: {
              orientation: 'h',
              x: 0.35,
              y: -0.6,
              xanchor: 'center',
              yanchor: 'top',
              itemclick: false, // Disables toggling on click
              itemdoubleclick: false, // Disables toggling on double-click
            },
            font: {
              size: 8,
            },
            bargap: 0.05, 
            bargroupgap: 0.2, 
            barmode:"stack",
            title: config ? `${config.title}` : "...loading", 
            xaxis: {
              title: config?.status?.data ? "" : (config ? config.title : "...loading"),
              tickfont: {
                size: config?.title === "Treatment Color" ? 6.5 : 8,
              }
            }, 
            yaxis: {
              title: `${config.entity.charAt(0).toUpperCase() + config.entity.slice(1)} Count`
            },
            autosize: true,
            plot_bgcolor:"#ffffff00",
            paper_bgcolor:"#ffffff00"
          }}
          //useResizeHandler={true}
          //style={{width: "100%", height: "100%"}}
          style={{
            width: "240px", 
            height: "225px"
          }}
          onHover={(params:any) => graphHover(params)}
          onSelected={(params: any) => console.log("x040223 params", params)}
          onDeselect={() => console.log("x040223 onDeselect")}
          //onLegendClick={(params: any) => console.log("022024 params", params)} 
          onClick={(params: any) => {
            console.log("x040223 params", params)
            if(params.points.length /*&& onClick*/) {
              // convert the clicked poisition to data position
              const bb = params.event.target.getBoundingClientRect();
              const y = params.points[0].yaxis.p2d(params.event.clientY - bb.top);
              const x = params.points[0].yaxis.p2d(params.event.clientX - bb.left);
              const xbins = params.points[0].fullData.xbins;
              const binNumber = params.points[0].binNumber;
              const minBin = xbins.start + (xbins.size * binNumber); 
              const maxBin = minBin + xbins.size; 
              const selectionRange = [minBin,maxBin];
              setDwFilters((prevState:any) => {
                let newState = {...prevState};
                newState[config.title] = {
                    selectionRange,
                    config
                }
                newState["version"] = (newState["version"] ? parseInt(newState["version"]) + 1 : 0).toString();
                return newState
              }
              )
            }
          }}
      />
      </div>
    }
    </>
  );
}


export default ClassedHistogramPlot;